import React from 'react';
import './style.css';

// Helper function to get card image from card code
const getCardImage = (cardCode) => {
  if (!cardCode) return null;
  try {
    if (cardCode.length < 2) {
      return null;
    }
    return `/assets/img/cards/${cardCode}.png`;
  } catch (e) {
    return null;
  }
};

// Parse AB20 cards - separate Andar and Bahar cards from card string
const parseAB20Cards = (cardString, aall = "", ball = "") => {
  if (!cardString) return { andarCards: [], baharCards: [] };

  const allCards = cardString.split(',').map(c => c.trim()).filter(c => c);

  let andarCardCodes = [];
  let baharCardCodes = [];

  if (aall && ball) {
    andarCardCodes = aall.split(',').map(c => c.trim()).filter(c => c);
    baharCardCodes = ball.split(',').map(c => c.trim()).filter(c => c);
  } else {
    // Fallback: alternate distribution (first card to Andar, second to Bahar, etc.)
    allCards.forEach((cardCode, index) => {
      if (index % 2 === 0) {
        andarCardCodes.push(cardCode);
      } else {
        baharCardCodes.push(cardCode);
      }
    });
  }

  const andarCards = andarCardCodes.map(code => ({
    code,
    image: getCardImage(code)
  }));

  const baharCards = baharCardCodes.map(code => ({
    code,
    image: getCardImage(code)
  }));

  return { andarCards, baharCards };
};

// Parse AB20 result - extract winner (Andar or Bahar)
const parseRdesc = (rdesc) => {
  if (!rdesc) return { winner: "" };
  return {
    winner: rdesc.trim() || ""
  };
};

const AB20 = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
  const aall = detailResult?.aall || '';
  const ball = detailResult?.ball || '';
  const cardData = detailResult?.card ? parseAB20Cards(detailResult.card, aall, ball) : { andarCards: [], baharCards: [] };
  
  const rdesc = detailResult?.rdesc || "";
  const winValue = detailResult?.win || "";
  const winnat = detailResult?.winnat || "";

  let winner = "";
  if (rdesc) {
    const parsed = parseRdesc(rdesc);
    winner = parsed.winner;
  } else if (winnat) {
    winner = winnat;
  } else if (winValue) {
    // Map win value: "1" or "A" -> "Andar", "2" or "B" -> "Bahar"
    if (winValue === "1" || winValue === "A" || winValue.toLowerCase() === "a") {
      winner = "Andar";
    } else if (winValue === "2" || winValue === "B" || winValue.toLowerCase() === "b") {
      winner = "Bahar";
    } else {
      winner = winValue;
    }
  }

  return (
    <div className="modal-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <h6 className="text-right">
              <b>Round Id :</b> {roundId}
            </h6>
          </div>
        </div>
        <div className="row bottom-border-casino m-t-10">
          <div className="col-md-12">
            {/* Andar Cards */}
            {cardData.andarCards && cardData.andarCards.length > 0 && (
              <div className="m-b-20">
                <h6 className="text-center">Andar</h6>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '5px' }}>
                  {cardData.andarCards.map((card, index) => (
                    <img
                      key={`andar-${index}`}
                      src={card.image || `/assets/img/cards/patti_back.png`}
                      alt={card.code}
                      style={{ height: '80px', width: 'auto' }}
                      onError={(e) => {
                        e.target.src = `/assets/img/cards/patti_back.png`;
                      }}
                    />
                  ))}
                </div>
              </div>
            )}

            {/* Bahar Cards */}
            {cardData.baharCards && cardData.baharCards.length > 0 && (
              <div className="m-b-20">
                <h6 className="text-center">Bahar</h6>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '5px' }}>
                  {cardData.baharCards.map((card, index) => (
                    <img
                      key={`bahar-${index}`}
                      src={card.image || `/assets/img/cards/patti_back.png`}
                      alt={card.code}
                      style={{ height: '80px', width: 'auto' }}
                      onError={(e) => {
                        e.target.src = `/assets/img/cards/patti_back.png`;
                      }}
                    />
                  ))}
                </div>
              </div>
            )}

            {/* Winner */}
            <div className="col-md-12 text-left">
              <p className="m-b-0 m-t-20">
                <b>Winner:</b> {winner || "N/A"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AB20;

